import 'reflect-metadata';
import { container } from 'tsyringe';
import React, { createContext, Component } from 'react';
import { defaultExtensions } from './../extensions';
import { BuiltInId } from './../extensions/locales-defaults';
import { ExtensionService, } from './../services/extensionService';
import { LocaleService } from './../i18n';
import { STORE_KEY, DEFAULT_LOCALE_ID } from './../i18n/localeService';
import { MonacoService } from './../monaco/monacoService';
import { LayoutService } from './../services';
import * as controllers from './../controller';
export const MoleculeCtx = createContext({});
export class MoleculeProvider extends Component {
    constructor(props) {
        super(props);
        this.monacoService = container.resolve(MonacoService);
        this.extensionService = container.resolve(ExtensionService);
        this.layoutService = container.resolve(LayoutService);
        this.localeService = container.resolve(LocaleService);
    }
    componentDidMount() {
        if (!this.extensionService.isLoaded()) {
            this.initialize();
        }
    }
    initialize() {
        const { extensions = [] } = this.props;
        const [languages, restExts] = this.extensionService.splitLanguagesExts(extensions);
        // First to init the monacoService
        this.monacoService.initWorkspace(this.layoutService.container);
        // Molecule should load the language extensions first to
        // ensure that the custom language extensions is registered in localeService
        this.initLocaleExts(languages);
        // The Workbench depends on the monaco and locale extension
        this.initWorkbenchUI();
        // Init the built-in extensions
        this.extensionService.load(defaultExtensions);
        // Finally, handle the rest of extensions
        this.extensionService.load(restExts);
        // Mark the extensionService as loaded
        this.extensionService.setLoaded();
    }
    initLocaleExts(languages) {
        const { defaultLocale = BuiltInId } = this.props;
        this.extensionService.load(languages);
        // And Molecule should set the correct locale before loading normal extensions in case of
        // the localize method returns incorrect international text caused by incorrect current locale in the normal extensions
        const currentLocale = localStorage.getItem(STORE_KEY) || defaultLocale;
        const preDefaultLocale = localStorage.getItem(DEFAULT_LOCALE_ID);
        let finalLocale = currentLocale;
        if (defaultLocale !== preDefaultLocale) {
            finalLocale = defaultLocale;
        }
        this.localeService.setCurrentLocale(finalLocale);
        localStorage.setItem(DEFAULT_LOCALE_ID, defaultLocale);
    }
    /**
     * Register all controllers and execute the initView method automatically to inject the default value
     * into the corresponding service
     */
    initWorkbenchUI() {
        Object.keys(controllers).forEach((key) => {
            var _a;
            const module = controllers[key];
            const controller = container.resolve(module);
            (_a = controller.initView) === null || _a === void 0 ? void 0 : _a.call(controller);
        });
    }
    render() {
        return (React.createElement(MoleculeCtx.Provider, { value: {} }, this.props.children));
    }
}
